import {get} from '@/lib/request'

function testimonialIndexPath() {
  return `/wp/v2/testimonials`
}

export function listTestimonials(params = {}) {
  return get(testimonialIndexPath(), params)
}
